import React from 'react'
import { terms } from './termsData'

import './termsSection.scss'

const TermsSection = () => {
  return (
    <div className="f-termsSection-container">
      <div
        id="terminos-y-condiciones"
        className="f-termsSection-container__ancla"
      />
      <h2>TÉRMINOS Y CONDICIONES</h2>
      <div className="f-termsSection-container__info">
        <ul>
          {terms.map((item, index) => {
            return (
              <li key={index}>
                <span>{index + 1}.</span> {item}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default TermsSection
